import React, { useEffect, useRef } from "react"
import axios from "axios"
import { LoadingPage } from "../LoadingPage"

const POLL_INTERVAL_MS = 15000
const POLL_TIMEOUT_MS = 120000

export const AwaitingEnvelopeSubmit = (props) => {
    const {
        signerHash,
        setSignerStep,
        setSignData,
        clearAwaitingEnvelopeSubmit,
        pendingNextStep,
    } = props

    const stoppedRef = useRef(false)

    useEffect(() => {
        stoppedRef.current = false

        const poll = async () => {
            if (stoppedRef.current) return
            try {
                const response = await axios.get('/signer/hash/' + signerHash)
                if (stoppedRef.current) return

                setSignData((prev) => ({ ...prev, ...(response.data || {}) }))

                if (response?.data?.next_step_blocked === false) {
                    stoppedRef.current = true
                    const resumeStep = response?.data?.next_step || pendingNextStep
                    clearAwaitingEnvelopeSubmit()
                    if (resumeStep) {
                        setSignerStep(resumeStep)
                    }
                    return
                }
            } catch {}
        }

        poll()
        const interval = setInterval(poll, POLL_INTERVAL_MS)
        const timeout = setTimeout(() => {
            stoppedRef.current = true
            clearInterval(interval)
        }, POLL_TIMEOUT_MS)

        return () => {
            stoppedRef.current = true
            clearInterval(interval)
            clearTimeout(timeout)
        }
    }, [signerHash, setSignerStep, setSignData, clearAwaitingEnvelopeSubmit, pendingNextStep])

    return <LoadingPage />
}
